// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FollowUp30DayForm__wrapper__rW8-n","submitResult":"FollowUp30DayForm__submitResult__3jO1a","toggleHeadline":"FollowUp30DayForm__toggleHeadline__3eAxT","collapseIcon":"FollowUp30DayForm__collapseIcon__2_5hW","headlineText":"FollowUp30DayForm__headlineText__lsBb9","sliderWrapper":"FollowUp30DayForm__sliderWrapper__2e4BN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowUp30DayForm/FollowUp30DayForm.css
// module id = 2913
// module chunks = 0